import * as r from 'ramda';

import { getArtSkuTypesByOrientation } from './getArtSkuTypesByOrientation';

export const findArtSkuTypeForAdjust = (orientation, naturalWidth, naturalHeight) => {
  const orientationSkuTypes = getArtSkuTypesByOrientation(orientation);

  if (orientation === 'same') {
    return orientationSkuTypes.find(r.propEq('aspectRatio', '30:30'));
  }

  const naturalAspectRatio = naturalWidth / naturalHeight;

  const skuAspectRatios = orientationSkuTypes.map(({ getFrameSettings }) => {
    const { width, height } = getFrameSettings();
    return width / height;
  });

  const aspectRatioDiffs = skuAspectRatios.map((ratio) => Math.abs(ratio - naturalAspectRatio));
  const minAspectRatioDiff = Math.min(...aspectRatioDiffs);
  const minAspectRatioDiffIndex = aspectRatioDiffs.indexOf(minAspectRatioDiff);

  return orientationSkuTypes[minAspectRatioDiffIndex];
};
